import React, { Component } from 'react';
import * as QueryAI from '../../../../ComplianceView/AIQuestion/AIQuestionQuery';
import { MyContext } from '../../../../../context';
import { Query } from 'react-apollo';
import { DocumentCard, DocumentCardDetails, Stack, Spinner, Text, mergeStyleSets, ScrollablePane } from 'office-ui-fabric-react';
import AIDisclaimer from '../../../../common/AIDisclaimer';

export default class AIAssistantResults extends Component {

    static contextType = MyContext
    constructor(props) {
        super(props);
        this.state = {
            aIAssistantQuestions: [],
            aIAssistantResults: []
        };
    }

    render() {
        let aIResultHistory;
        //let conversationId = "25c6b095-2360-4a2d-ad31-15cd9cc74af2";
        let conversationId = this.props.metadata.conversationId;
        const classNames = mergeStyleSets({
            wrapper: {
                height: this.props.height,
                position: 'relative',
                minHeight: '100px'
            },
            pane: {
            }
        });
        return (<div>


            <div className={classNames.wrapper}>
                <ScrollablePane styles={{ root: classNames.pane }}>
                    <Query
                        query={QueryAI.queryAllAIAssistantResults}
                        variables={{ conversationId }}>
                        {({ loading, error, data, refetch }) => {
                            this.refetchQueryVersions = refetch
                            if (loading) {
                                return (<Spinner label={this.context.getTranslation("common", "loading")} ariaLive="assertive" labelPosition="top" />)
                            }
                            if (error || data.getAllAIAssistantResults == null) {
                                return ""
                            }
                            aIResultHistory = data.getAllAIAssistantResults.sort((a, b) => {
                                return Date.parse(b.answerDate) - Date.parse(a.answerDate);
                            });
                            return (<div style={{ width: '100%', maxWidth: '100%' }}>
                                {aIResultHistory.length > 0 && (
                                    <Stack tokens={{ childrenGap: 16 }} style={{ width: '100%' }}>
                                        {aIResultHistory.map((item, index) => (
                                            <DocumentCard
                                                key={index}
                                                style={{ width: '100%', maxWidth: 'none' }}
                                            >
                                                <DocumentCardDetails>
                                                    <Stack tokens={{ childrenGap: 8 }} style={{ paddingTop: '16px', paddingBottom: '16px' }} >
                                                        <Stack horizontal tokens={{ childrenGap: 16 }}>
                                                            <Stack.Item grow style={{ paddingLeft: '16px' }}>
                                                                <Text variant="large" style={{ fontWeight: 'bold', userSelect: "text" }}>{item.question}</Text>
                                                            </Stack.Item>
                                                            <Stack.Item>
                                                                <div style={{ width: 90 }}>
                                                                    <Text variant="small">
                                                                        {item.automated == true ? "Automated" : "On Demand"}
                                                                    </Text>
                                                                </div>
                                                            </Stack.Item>
                                                        </Stack>
                                                        <Stack horizontal tokens={{ childrenGap: 16 }}>
                                                            <Stack.Item grow style={{ paddingLeft: '16px' }}>
                                                                <Text variant="medium"
                                                                    style={{ userSelect: "text" }}>
                                                                    {item.answer}
                                                                </Text>
                                                            </Stack.Item>
                                                            <Stack.Item>
                                                                <div style={{ width: 180 }}>
                                                                    <Text variant="medium">{`${new Date(item.answerDate).toISOString().replace('T', ' ').slice(0, 19)} UTC`}</Text>
                                                                </div>
                                                            </Stack.Item>
                                                        </Stack>
                                                    </Stack>
                                                </DocumentCardDetails>
                                            </DocumentCard>
                                        ))}
                                    </Stack>
                                )}
                                {aIResultHistory.length === 0 && (<div style={{ paddingLeft: '11px' }}>
                                    <Text variant="medium" style={{ fontWeight: 'bold' }}>
                                        No history found
                                    </Text>
                                </div>)}
                            </div>
                            )
                        }}
                    </Query>
                </ScrollablePane>
            </div>
            <AIDisclaimer theme={this.props.theme} />
        </div>)
    }
}